import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";

const StatsPage = dynamic(() => import("@/screens/IplPage/Stats"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  faqData = null,
  statsData = null,
  mostRunData = null,
  mostWicketsData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <StatsPage
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          faqData={faqData}
          statsData={statsData}
          mostRunData={mostRunData}
          mostWicketsData={mostWicketsData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getStatsPlayer, getMostWickects, getMostRuns } = await import(
      "@/handlers/ipl"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/sports",
        page: page,
        display: 6,
        type: "story",
      },
    });

    let faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "ipl-2025-faqs" },
    });

    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    let tourID = 8307; //2025 tour id
    const getStats = async () => {
      try {
        const statsData = await getStatsPlayer(tourID, 0);

        if (statsData) {
          return statsData;
        }
        return null;
      } catch (err) {
        logger.error(err);
      }
    };
    // get most runs
    const getMostRunsPlayer = async () => {
      try {
        const mostRunData = await getMostRuns();

        if (mostRunData) {
          return mostRunData;
        }
        return null;
      } catch (err) {
        logger.error(err);
      }
    };
    // get most wickets
    const getMostWicketsPlayer = async () => {
      try {
        const mostWicketsData = await getMostWickects();

        if (mostWicketsData) {
          return mostWicketsData;
        }
        return null;
      } catch (err) {
        logger.error(err);
      }
    };
    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      faqData,
      statsData,
      mostRunData,
      mostWicketsData,
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: "/sports",
          page: page,
          display: 6,
          type: "story",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      fetchRedisWrapper(faqRedisKey, () =>
        getFaqBySlug({
          url: "ipl-2025-faqs",
        })
      ),

      getStats(),
      getMostRunsPlayer(),
      getMostWicketsPlayer(),
    ]);

    setPageTTL(ctx, 120);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        faqData,
        statsData,
        mostRunData,
        mostWicketsData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
